import * as React from 'react';
import { Box } from '@lifeomic/chroma-react/components/Box';
import {
  BagOfChips,
  ContentContainer,
  FilterContainer,
  FilterContentLayoutManager,
} from '@lifeomic/phc-web-toolkit/src/components/FilterContent';
import { defineMessages, useIntl } from 'react-intl';
import { ExpansionPanel } from '@lifeomic/chroma-react/components/ExpansionPanel';
import {
  handleFilterAdd,
  handleFilterRemove,
} from '../FilterResultsManager/utils';
import { makeStyles } from '@lifeomic/chroma-react/styles';

const useStyles = makeStyles(theme => ({
  filterContentLayoutManager: {
    height: `calc(100vh - ${theme.pxToRem(185)})`,
  },
  contentContainer: {
    background:
      theme.palette.mode === 'dark'
        ? theme.palette.background.default
        : theme.palette.black[50],
    maxHeight: '100%',
    maxWidth: '100%',
    padding: theme.spacing(2),
  },
}));

const messages = defineMessages({
  chipTooltipOriginName: {
    id: 'omicsExplorer.variantDetails.knowledgeFilterLayout.chipTooltipOriginName',
    defaultMessage: '{origin} / {title}',
  },
});

export const KnowledgeFilterLayout = ({
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  children,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  filterOptions,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  selectedFilterOptions,
  // @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
  setSelectedFilterOptions,
}) => {
  const classes = useStyles({});
  const { formatMessage } = useIntl();

  return (
    <Box fullWidth data-testid="knowledge-filter-layout">
      <FilterContentLayoutManager
        className={classes.filterContentLayoutManager}
        filter={
          <FilterContainer>
            {filterOptions?.map((option: any, index: any) => {
              const { content: FilterContent, id, title, ...props } = option;

              return (
                <ExpansionPanel
                  data-testid="filter"
                  key={index}
                  title={formatMessage(title)}
                >
                  <FilterContent
                    {...props}
                    onFilterAdd={(option: any) =>
                      handleFilterAdd({
                        option,
                        selectedFilterOptions,
                        setSelectedFilterOptions,
                      })
                    }
                    onFilterRemove={(option: any) =>
                      handleFilterRemove({
                        option,
                        selectedFilterOptions,
                        setSelectedFilterOptions,
                      })
                    }
                    origin={formatMessage(title)}
                    selectedFilterOptions={selectedFilterOptions}
                  />
                </ExpansionPanel>
              );
            })}
          </FilterContainer>
        }
      >
        <ContentContainer
          contentClass={classes.contentContainer}
          header={
            <BagOfChips
              chipLabel={filter => filter.searchValue}
              onChipDelete={option =>
                handleFilterRemove({
                  option,
                  selectedFilterOptions,
                  setSelectedFilterOptions,
                })
              }
              options={selectedFilterOptions}
              tooltipTitle={filter =>
                formatMessage(messages.chipTooltipOriginName, {
                  origin: filter.origin,
                  title: filter.searchValue,
                })
              }
            />
          }
        >
          {children}
        </ContentContainer>
      </FilterContentLayoutManager>
    </Box>
  );
};
